import { render, staticRenderFns } from "./ExpencesCategoryForm.vue?vue&type=template&id=047b1c0e&scoped=true"
import script from "./ExpencesCategoryForm.vue?vue&type=script&lang=js"
export * from "./ExpencesCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./ExpencesCategoryForm.vue?vue&type=style&index=0&id=047b1c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b1c0e",
  null
  
)

export default component.exports